import 'moment/locale/ar';
import 'moment/locale/zh-cn';
import 'moment/locale/fr';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/pt';
import 'moment/locale/ru';
import 'moment/locale/es';
import 'moment/locale/fa';
export const languages = {
    ar: {
        direction: 'rtl',
        name: 'Arabic',
        nativeName: 'العربية',
    },
    en: {
        direction: 'ltr',
        name: 'English',
        nativeName: 'English',
    },
    fr: {
        direction: 'ltr',
        name: 'French',
        nativeName: 'Français, langue française',
    },
    fa: {
        direction: 'rtl',
        name: 'Persian',
        nativeName: 'فارسی',
    },
    pt: {
        direction: 'ltr',
        name: 'Portuguese',
        nativeName: 'Português',
    },
    es: {
        direction: 'ltr',
        name: 'Spanish',
        nativeName: 'Español',
    },
};
export const languageList = (t) => Object.keys(languages).map(key => ({
    name: t ? t(languages[key].nativeName) : languages[key].nativeName,
    value: key,
}));
export default languages;
